const shows_saturday = [
    {
        name: 'Xander Guzman',
        shcedule: 'Saturday 20:00',
        day: 6,
        time: 20,
        img: require('../../../img/weekly/saturday20.png')
    },
    {
        name: 'Involver29',
        shcedule: 'Saturday 21:00',
        day: 6,
        time: 21,
        img: require('../../../img/weekly/saturday21.png')
    },
    {
        name: 'Dj Tøre',
        shcedule: 'Saturday 22:00',
        day: 6,
        time: 22,
        img: require('../../../img/weekly/saturday22.jpg')
    },
    {
        name: 'MASTIK GROOVE',
        shcedule: 'Saturday 23:00',
        day: 7,
        time: 23,
        img: require('../../../img/weekly/saturday23.png')
    },
]

export default shows_saturday;